import * as React from 'react';

function SvgProgressApplicationForm(props) {
  return (
    <svg viewBox="0 0 18 21" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.5 3H12a3 3 0 00-6 0H4.5v1.5h9V3zm-6 0a1.5 1.5 0 013 0h-3zm8.786 0H15v1.5h.643c.473 0 .857.384.857.857v13.286a.857.857 0 01-.857.857H2.357a.857.857 0 01-.857-.857V5.357c0-.473.384-.857.857-.857H3V3H1.714C.768 3 0 3.767 0 4.714v14.572C0 20.232.767 21 1.714 21h14.572c.946 0 1.714-.767 1.714-1.714V4.714C18 3.768 17.233 3 16.286 3zM4.5 16.5h9a.75.75 0 000-1.5h-9a.75.75 0 000 1.5zm0-3.75h9a.75.75 0 000-1.5h-9a.75.75 0 000 1.5zM4.5 9h9a.75.75 0 000-1.5h-9a.75.75 0 000 1.5z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgProgressApplicationForm;
